import React from 'react';
import { Link, NavLink } from 'react-router';
import { useUser } from '../../context/UserContext';
import { ADMIN_NAV, filterAdminNav } from '../../config/adminNav';

/**
 * AdminShell (DOS-388) — shared chrome for `/admin/*` pages.
 *
 * Renders a horizontal sub-nav filtered to the current user's admin
 * capabilities, then the page content below. Pages continue to render inside
 * the main `<Layout>`; AdminShell adds only the admin-scoped chrome.
 *
 * Route-level access enforcement is a separate concern (Phase B).
 */
export default function AdminShell({ children }) {
  const user = useUser();
  const items = filterAdminNav(user, ADMIN_NAV);

  return (
    <div className="flex flex-col h-full min-h-0">
      <nav
        aria-label="Admin sections"
        className="border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 overflow-x-auto"
      >
        <ul className="flex items-center gap-1 px-4 py-2 min-w-max">
          {/* The only way out of /admin/* other than the browser's back button. */}
          <li className="pr-2 mr-1 border-r border-gray-200 dark:border-gray-700">
            <Link
              to="/"
              className="inline-flex items-center px-3 py-1.5 text-sm rounded-md transition-colors whitespace-nowrap text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"
            >
              <span aria-hidden="true" className="mr-1">←</span>
              Back to chat
            </Link>
          </li>
          <li>
            <NavLink
              to="/admin"
              end
              className={({ isActive }) =>
                `inline-flex items-center px-3 py-1.5 text-sm rounded-md transition-colors whitespace-nowrap ${
                  isActive
                    ? 'bg-decisiv-blue text-white'
                    : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800'
                }`
              }
            >
              Admin
            </NavLink>
          </li>
          {items.map(item => (
            <li key={item.path}>
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `inline-flex items-center px-3 py-1.5 text-sm rounded-md transition-colors whitespace-nowrap ${
                    isActive
                      ? 'bg-decisiv-blue text-white'
                      : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800'
                  }`
                }
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
      <div className="flex-1 min-h-0 overflow-y-auto">
        {children}
      </div>
    </div>
  );
}
